import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1f5443ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "flex some-inputs" }
const _hoisted_4 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Slug", -1))
const _hoisted_6 = { class: "flex flex-col input-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Имя параметра", -1))
const _hoisted_8 = { class: "flex flex-col fl-1 m-b-8 m-t-8" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Описание", -1))
const _hoisted_10 = { class: "flex some-inputs m-t-8" }
const _hoisted_11 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Значение по умолчанию", -1))
const _hoisted_13 = { class: "flex flex-col input-container" }
const _hoisted_14 = { class: "flex m-t-30 m-b-8 fl-jc-sb" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "updated",
  class: "m-r-20"
}, "Отображать в настройках эстимации", -1))

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useEstimationParamsStore } from "@/store/dictionaries/estimation_params";

import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Textarea from "primevue/textarea";

import { areEstimationParamFieldsValid } from "@/services/dictionaries/estimation_params";
import InputSwitch from "primevue/inputswitch";
import SceletonInput from "@/shared/forms/SceletonInput.vue";

import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimationParamCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const route = useRoute();
const router = useRouter();
const store = useEstimationParamsStore();

const param = ref({
  name: "",
  slug: "",
  description: "",
  default_value: null as number | null,
  active: true,
});

const isInvalidForm = ref(false);
const isParamSetted = computed(() => {
  return Boolean(route.params.id);
});
const isLoadingData = ref(false);

const reload = () => {
  if (isParamSetted.value) {
    const paramId = parseInt(route.params.id);
    isLoadingData.value = true;
    store
      .getEstimationParam(paramId)
      .then((paramClone) => {
        if (paramClone) {
          param.value.name = paramClone.name;
          param.value.slug = paramClone.slug;
          param.value.description = paramClone.description;
          param.value.active = paramClone.active;
          param.value.default_value = paramClone.default_value;
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

const createEstimationParam = () => {
  if (!areEstimationParamFieldsValid(param.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`
    );
    return;
  }
  emit("setLoading", true);
  if (!isParamSetted.value) {
    performParamAction(() => store.createEstimationParam(param.value));
  } else {
    performParamAction(() =>
      store.updateEstimationParam(param.value, parseInt(route.params.id))
    );
  }
};

const performParamAction = (action: any) => {
  const handleSuccess = () => {
    router.push({ name: "estimationParams" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

__expose({
  createEstimationParam,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                id: "slug",
                placeholder: "Введите значение",
                modelValue: param.value.slug,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((param.value.slug) = $event)),
                invalid: isInvalidForm.value && param.value.slug == ''
              }, null, 8, ["modelValue", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                id: "name",
                placeholder: "Введите значение",
                modelValue: param.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((param.value.name) = $event)),
                invalid: isInvalidForm.value && param.value.name == ''
              }, null, 8, ["modelValue", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(Textarea), {
              autoResize: "",
              invalid: isInvalidForm.value && param.value.description == '',
              modelValue: param.value.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((param.value.description) = $event)),
              rows: "5",
              cols: "30"
            }, null, 8, ["invalid", "modelValue"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputNumber), {
                placeholder: "Введите значение",
                modelValue: param.value.default_value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((param.value.default_value) = $event)),
                maxFractionDigits: 10,
                invalid: isInvalidForm.value && param.value.default_value == null
              }, null, 8, ["modelValue", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_unref(InputSwitch), {
              modelValue: param.value.active,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((param.value.active) = $event)),
              inputId: "updated"
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}
}

})